module.exports = __webpack_public_path__ + "static/img/policePerson.ef1ba06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policePerson.png
// module id = vgqW
// module chunks = 208